import { render } from "./TodoList.vue?vue&type=template&id=8a49de26"
import script from "./TodoList.vue?vue&type=script&lang=ts"
export * from "./TodoList.vue?vue&type=script&lang=ts"

import "./TodoList.vue?vue&type=style&index=0&id=8a49de26&lang=css"
script.render = render

export default script